import { useTranslation } from 'react-i18next';

import RecipeCategory from 'classes/StandingData/RecipeCategory/RecipeCategory';

interface IProps {
	recipeCategory: RecipeCategory;
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	selectedLanguage: string;
}

const RecipeCategoryLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-2">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:NAME')}</label>
							<div>
								<input
									value={
										props.recipeCategory.nameTranslations[
											props.selectedLanguage
										] || ''
									}
									type="text"
									onChange={props.handleValueChange}
									className="form-control"
									name="nameTranslations"
									error-key={'NameTranslations'}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default RecipeCategoryLanguageInput;
